module.exports = __webpack_public_path__ + "static/img/1025.2263e05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1025.jpg
// module id = 207
// module chunks = 0